<template>
  <div class="app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 4" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row>
        <v-col>
          <v-text-field
            dense
            :value="form.description.toUpperCase()"
            :error-messages="descriptionErrors"
            :counter="30"
            label="Descrição do Agendamento"
            outlined
            @input="
              $v.form.description.$touch()
              form.description = $event.toUpperCase().trim()
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
        <v-col>
          <v-select
            dense
            v-model="form.mes"
            :items="mes"
            :error-messages="mesErrors"
            label="Mês"
            outlined
            @input="$v.form.mes.$touch()"
            @blur="$v.form.mes.$touch()"
          />
        </v-col>
        <v-col>
          <v-select
            dense
            v-model="form.diaMes"
            :items="
              form.mes === 1 ||
              form.mes === 3 ||
              form.mes === 5 ||
              form.mes === 7 ||
              form.mes === 8 ||
              form.mes === 10 ||
              form.mes === 12
                ? diaMes
                : form.mes === 2
                ? diaMesFevereiro
                : diaMesTrinta
            "
            :error-messages="diaMesErrors"
            label="Dia do Mês"
            outlined
            @input="$v.form.diaMes.$touch()"
            @blur="$v.form.diaMes.$touch()"
          />
        </v-col>
        <v-col>
          <v-menu
            ref="menu"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="time"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                dense
                v-model="form.hora"
                label="Hora"
                prepend-inner-icon="mdi-clock-outline"
                v-bind="attrs"
                v-on="on"
              />
            </template>

            <v-time-picker
              v-if="menu2"
              v-model="form.hora"
              scrollable
              no-title
              format="24hr"
              color="bluePcm"
              @click:minute="$refs.menu.save(time)"
            />
          </v-menu>
        </v-col>
      </v-row>
      <DraggAndDrop
        dragname="Ações"
        :valoresDisponiveisComboBox="acoesDisponiveis"
        @dragUpdate="updateAcoes($event)"
        :opcoesSelecionadas="acoesSelecionadas"
        class="mr-4"
      />

      <v-divider dark vertical />
      <v-divider dark />
      <v-divider dark vertical />
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'

import agendamentosStore from '../_store'
import acoes from '../_components/acoes'
import AgendamentosHttpService from '../_services/AgendamentosHttpService'
import { validateData, validateComputed } from '../_validates/validateAno'

import DraggAndDrop from './DraggAndDrop'

export default {
  name: 'AbaAgendamentoMes',
  mixins: [validationMixin],
  props: {
    _id: String,
  },
  components: { Snackbar, DraggAndDrop, FixedButtons },

  data: () => ({
    time: null,
    menu2: false,
    modal2: false,
    form: {
      active: true,
      description: '',
      tipo: 'anual',
      mes: '',
      diaMes: '',
      hora: moment().format('HH:mm'),
      acao: [],
    },
    acoesSelecionadas: [],
    acoesDisponiveis: [...acoes],
    mes: [
      { value: 1, text: 'Janeiro' },
      { value: 2, text: 'Fevereiro' },
      { value: 3, text: 'Marco' },
      { value: 4, text: 'Abril' },
      { value: 5, text: 'Maio' },
      { value: 6, text: 'Junho' },
      { value: 7, text: 'Julho' },
      { value: 8, text: 'Agosto' },
      { value: 9, text: 'Setembro' },
      { value: 10, text: 'Outubro' },
      { value: 11, text: 'Novembro' },
      { value: 12, text: 'Dezembro' },
    ],
    diaMes: [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
    ],
    diaMesTrinta: [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
    ],
    diaMesFevereiro: [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
    ],
    text: '',
    snackbar: false,
    open: false,
    hora: moment(),
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('abaAgendamentoTarefaAnoModulePABXStore', ['getagendamentoSelecionado']),
  },

  async created() {
    registerVuexModule(this.$store, 'abaAgendamentoTarefaAnoModulePABXStore', agendamentosStore)

    if (this._id) {
      this.form = this.getagendamentoSelecionado

      this.acoesSelecionadas = Object.values(this.getagendamentoSelecionado.acao)
    }
    this.showSkeleton = false
  },

  methods: {
    cancelEvent(parent) {
      parent.resetPicker()
      this.$emit('input', null)
    },

    updateAcoes(event) {
      this.form.acao = event
    },

    async salvar() {
      let count = 0
      this.pararLoader.parar = false

      if (this.form.acao.length > 0) {
        this.form.acao.forEach(reg => {
          if (reg.regex_id || reg.agente_id != '' || reg.backup_total != '' || reg.deparment_id != '') {
            count++
          }
        })
        if (count <= 0) {
          this.text = 'Favor inserir os valores dentro da ação selecionada.'
          this.pararLoader.parar = true
          this.snackbar = true
          return
        }
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        if (this._id) {
          await AgendamentosHttpService.puttarefa(this.form)
        } else {
          await AgendamentosHttpService.posttarefa(this.form)
        }

        this.$router.push({ name: 'agendamento' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.pararLoader.parar = true
        this.snackbar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'agendamento' })
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
